import Swiper, { Pagination, Manipulation } from "swiper";
import { updateHoverSliders, addToGlobalThisRet, findControls } from "@plugins";

window.addEventListener("load", () => {
    initReviewSlider();
    updateHoverSliders();
});

function initReviewSlider() {
    const reviewSlider = document.querySelector(".js-reviews-slider");

    if (reviewSlider) {
        const sliderContainer = reviewSlider.querySelector(".js-reviews-slider-content");
        const controls = findControls(reviewSlider, ".js-reviews-slider-controls");

        const swiper = new Swiper(sliderContainer, {
            modules: [Pagination, Manipulation],
            speed: 400,
            pagination: {
                el: controls.pagination,
                clickable: true,
            },
            navigation: {
                prevEl: controls.buttonPrev,
                nextEl: controls.buttonNext,
            },
            breakpoints: {
                370: {
                    slidesPerView: 1.2,
                    spaceBetween: 16,
                },
                406: {
                    slidesPerView: 1.5,
                    spaceBetween: 16,
                },
                567: {
                    slidesPerView: 2,
                    spaceBetween: 16,
                },
                768: {
                    slidesPerView: 3,
                    spaceBetween: 16,
                },
            },
        });

        if (window.mobileMedia) {
            swiper.once("reachEnd", () => {
                swiper.appendSlide(`
                    <div class="swiper-slide slider-link-load-more reviews-slider__load-more js-load-more-reviews-slider">
                        <span class="simple-link reviews-slider__load-more-btn"> 
                            Смотреть все <br>
                            88 отзывов
                        </span>
                    </div>
                `);
                document
                    .querySelector(".js-load-more-reviews-slider")
                    .addEventListener("click", () => {
                        document.querySelector(".js-reviews-slider-link").click();
                    });
            });
        }
    }
}

addToGlobalThisRet(initReviewSlider, "initReviewSlider");
